export const getPathEntityId = (entity: string, pathname?: string): number | undefined => {
    const regex = new RegExp(`\\/${entity}s\\/(?<id>[\\d]+)`, 'i')
    const match = regex.exec(pathname ?? window.location.pathname)
    let id
    if (match !== null) {
        id = parseInt(match.groups?.id, 10)
    }
    return id
}
